<template>
    <div class="form-row">
		<input type="hidden" :disabled="Validate" />
        <div v-if="ShowButtonTop" class="col-lg-6 d-flex align-items-center">
            <h3>{{ NombreTabla }}</h3>
        </div>
        <div v-if="ShowButtonTop" class="col-lg-6 d-flex justify-content-end mb-2">
            <button
                @click="Nuevo"
                class="btn btn-pink"
                type="button"
                data-toggle="modal"
                :data-target="'#'+TituloBoton"
                data-backdrop="static"
                data-keyboard="false"
                ><i class="fa fa-plus-circle mr-1"></i>Nuevo
            </button>
        </div>
        <div class="col-lg-12">
            <CLoader :pConfigLoad="ConfigLoad">
                <template slot="BodyFormLoad">
                    <div class="table-responsive">
                        <table class="table-01 text-nowrap-mt-2">
                            <thead>
                                <tr>
                                    <slot name="header_table_form">
                                    </slot>
                                    <th v-if="ShowButton" class="tw-1 text-right">
                                        <button
                                            class="mr-2 btn-obs"
                                            type="button"
                                            data-backdrop="static"
                                            data-toggle="modal"
                                            :data-target="'#'+TituloBoton"
                                            data-keyboard="false"
                                            title="Agregar"
                                            @click="Nuevo"
                                        ><i class="fa fa-plus"></i></button>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <slot name="body_table_form"></slot>
                                <!-- <slot name="buttons_action_form"></slot> -->
                            </tbody>
                        </table>
                    </div>
                    
                </template>
            </CLoader>
			<Pagina
				v-show="ConfigListForm.ShowPager"
				:Filtro="ConfigListForm.Filtro"
				:Entrada="5"
				@Pagina="Filtrar"
			></Pagina>
        </div>
        
        
    </div>
</template>

<script>
	import Pagina from "@/components/Cpagina.vue";
    import CLoader from "./CLoader";
    export default{
        name:"Clistform",
        props:[
            "TituloBoton",
            "NombreTabla",
            "EmitSeccionTabla",
            "ShowButton",
            "ShowButtonTop",
            "pConfigLoad",
			"pShowPager",
			"pFiltro"
        ],
        components:{
            CLoader,
			Pagina
        },
        data(){
            return{
                ConfigListForm:{
                    TituloBoton:"",
                    NombreTabla:"",
                    EmitSeccionTabla:"",
                    ShowButton:false,
                    ShowButtonTop:false,
					ShowPager:true,
					Filtro:{}
                },
                ConfigLoad:{
				    ShowLoader: true,
				    ClassLoad:  true,
			    },
            }
        },
        methods:{
            Nuevo(){
                this.bus.$emit("NewModal_"+this.EmitSeccionTabla,true);
            },
			Filtrar(){
				this.bus.$emit("List_"+this.EmitSeccionTabla);
			}
        },
        created(){
            if (this.TituloBoton!=undefined){
                this.ConfigListForm.TituloBoton=this.TituloBoton;
            }
            if (this.NombreTabla!=undefined){
                this.ConfigListForm.NombreTabla=this.NombreTabla;
            }
            if (this.EmitSeccionTabla!=undefined){
                this.ConfigListForm.EmitSeccionTabla=this.EmitSeccionTabla;
            }
            if (this.ShowButton!=undefined){
                this.ConfigListForm.ShowButton=this.ShowButton;
            }
            if (this.ShowButtonTop!=undefined){
                this.ConfigListForm.ShowButtonTop=this.ShowButtonTop;
            }
			if (this.pShowPager!=undefined) {
                this.ConfigListForm.ShowPager=this.pShowPager;
            }
			// console.log(this.ConfigListForm.ShowPager);
        },
		computed:{
			Validate(){
				if (this.pShowPager!=undefined) {
                	this.ConfigListForm.ShowPager=this.pShowPager;
            	}
				if (this.pFiltro!=undefined) {
            	    this.ConfigListForm.Filtro=this.pFiltro;
            	}
				if (this.pConfigLoad!=undefined) {
                	this.ConfigLoad=this.pConfigLoad;
            	}	
			}
		}
    }
</script>
